export const cleanStemText = (text, { preserveLineMarkers = false } = {}) => {
  if (!text) return text;
  let cleaned = String(text);
  if (!preserveLineMarkers) {
    cleaned = cleaned.replace(/\{L\d+\}/g, "");
  }
  const mA = cleaned.match(/(?:^|[\n\r]\s*|\s+)(?:\(?a\)|a[).])\s+\S/i);
  const mB = cleaned.match(/(?:^|[\n\r]\s*|\s+)(?:\(?b\)|b[).])\s+\S/i);
  if (mA && mB && mA.index > 30) {
    return cleaned.substring(0, mA.index).trimEnd();
  }
  return cleaned;
};

export const extractSubCore = (text, label) => {
  if (!text || !label) return text;
  const esc = String(label).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const pattern = new RegExp(`(?:^|[\\n\\r])[ \\t]*${esc}[ \\t]*[).][ \\t]*`, "gi");
  let lastMatch = null;
  let match;
  while ((match = pattern.exec(text)) !== null) {
    lastMatch = match;
  }
  if (lastMatch && lastMatch.index > 5) {
    return String(text).substring(lastMatch.index + lastMatch[0].length).trim();
  }
  return text;
};

export const isComprehensionPassage = (question) =>
  question?.type === "grouped" &&
  (question?.passage_type === "comprehension" || (question?.question_text?.length ?? 0) > 400);

export const toSubLabel = (idx, sub) => {
  const paperNumber = sub?.paper_number;
  if (paperNumber != null && Number(paperNumber) !== 0 && String(paperNumber).trim() !== "") {
    return String(paperNumber);
  }
  return `${String.fromCharCode(97 + idx)})`;
};

export const countBlanksInText = (text) => {
  if (!text) return 0;
  const stripped = String(text).replace(/<[^>]+>/g, " ");
  const underscores = (stripped.match(/_{3,}/g) || []).length;
  const brackets = (stripped.match(/\[\s*\]/g) || []).length;
  const boxes = (stripped.match(/□/g) || []).length;
  return underscores + brackets + boxes;
};

export const groupedAnswerHasContent = (value) => {
  if (value == null || value === "") return false;
  if (Array.isArray(value)) return value.some((item) => item != null && String(item).trim() !== "");
  if (typeof value === "object") return String(value.text ?? "").trim() !== "" || !!value.drawing
    || (Array.isArray(value.interactive) && value.interactive.length > 0)
    // Edge-shape drawing answers are { points, edges, shape_label? } — an unlabelled shape has no string
    // value at all, so without these the part reads as unanswered in the palette. Edges alone count:
    // on a no_new_points part ("join the printed corners") they are the entire answer.
    || (Array.isArray(value.points) && value.points.length > 0)
    || (Array.isArray(value.edges) && value.edges.length > 0)
    || (Array.isArray(value.blanks) && value.blanks.some((v) => String(v ?? "").trim() !== ""))
    // A matching answer is a plain { leftItem: rightItem } map — no text/drawing/blanks key to look at.
    || Object.values(value).some((v) => typeof v === "string" && v.trim() !== "");
  return String(value).trim() !== "";
};
